// ----------------------------------------------------------------------

import { grey } from "@mui/material/colors";
import { Theme } from "@mui/material/styles";

const COLOR = "#fff";

export default function Input(theme: Theme) {
  return {
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: COLOR,
          border: `1px solid ${grey[400]}`,
          borderRadius: theme.shape.borderRadius,
          '&:hover': {
            backgroundColor: COLOR,
          },
          '&.Mui-focused': {
            backgroundColor: COLOR,
            borderColor: grey[400],
            borderWidth: 1
          },
          '&.Mui-disabled': {
            backgroundColor: COLOR
          },
        },
        error: {
          borderColor: '#f1416c',
          borderWidth: "2px"
        },
        underline: {
          "&&&:after": {
            borderBottom: "none"
          },
          '&&&:before': {
            borderBottom: "none"
          }
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          margin: 0
        }
      }
    }
  };
}
